import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/Rx';

import { NavigationService, Subscription } from '../core/navigation/navigation.service';
import { MessagingService } from '../core/messaging/messaging.service';
import { MainMenuService, Menu } from './main-menu.service';

@Component({
	selector: 'main-menu',
	template: require('./main-menu.component.html'),
	providers: [MainMenuService],
	styles: ['li.sidebar-toggler-wrapper { margin-bottom: 15px; }']
})
export class MainMenuComponent implements OnInit, AfterViewInit {
	ngAfterViewInit(): void {
		//setup search debounce
		const eventStream = Observable.fromEvent(this.searchInputElementRef.nativeElement, 'keyup')
			.map(() => this.searchTerm)
			.debounceTime(400)
			.distinctUntilChanged();

		eventStream.subscribe(input => {
			this.getMenu(input);
		});

		setTimeout(() => this.searchInputElementRef.nativeElement.focus());

	}

	public clear() {
		this.searchTerm = "";
		this.searchInputElementRef.nativeElement.dispatchEvent(new Event('keyup'));
		this.searchInputElementRef.nativeElement.focus();
	}


	private readonly navigationSubscripton: Subscription;

	deployment: string = "Unknown";
	builddate: string = "Unknown";

	constructor(
		private http: HttpClient,
		private readonly messagingService: MessagingService,
		private readonly menuService: MainMenuService,
		private readonly navigationService: NavigationService) {


		if (window && window["appConfig"] && window["appConfig"].environment) {
			this.deployment = window["appConfig"].environment;
		}

		this.http.get("builddate.txt", { responseType: 'text' }).toPromise().then(x => {

			this.builddate = x.replace("T", " ");

		});


		this.navigationSubscripton = this.navigationService.onNavigated.subscribe(route => {
			this.activateMenuItem(this.menu);
			this.activateMenuItem(this.adminMenu);
		});
	}

	ngOnInit(): void {
		this.getMenu();

		//an attempt to get the menu to update when necessary
		this.messagingService.subscribe("project.add", () => { this.getMenu(); });

		this.messagingService.subscribe("store.add", () => { this.getMenu(); });

		this.messagingService.subscribe("refresh-main-menu", () => { this.getMenu(); });

	}

	getMenu(query?: string): void {
		this.menu = null;
		this.menuService.getMenu(query).then(menu => {
			this.menu = menu;
			setTimeout(() => this.activateMenuItem(menu));
		});
	}

	toggleSidebar() {
		this.sideBarOpen = !this.sideBarOpen;

		if (document) {
			const body = document.getElementsByTagName("body").item(0);
			if (!this.sideBarOpen) {
				body.className += " page-sidebar-closed";
			} else {
				body.className = body.className.replace(/(?:^|\s)page-sidebar-closed(?!\S)/g, '');
			}
		}
	}

	private activateMenuItem(menu: Menu) {


		if (!menu) return;

		const route = this.navigationService.currentRoute;
		if (!route) return;

		let id: string;
		let routeId: string = route.snapshot.data['routeId'] || "";

		if (routeId.startsWith("project-")) {
			routeId = routeId.split('-')[0];

			id = route.parent.snapshot.params['storeId'] + "_" + route.snapshot.params['pid'];
		} else {
			// Traverse the url tree upwards to find potential id in parent routes
			let x = route;
			while (x && !x.snapshot.params['id']) {
				x = x.parent;
			}
			id = x ? x.snapshot.params['id'] : null;
		}

		const menuItem = menu.findItemById(routeId, id);
		if (menuItem) {
			menuItem.open();
		}
	}

	menu: Menu;
	adminMenu: Menu;
	sideBarOpen = true;

	searchTerm: string;

	fancyStoreName = (text: string): string => {
		if (!!text) {
			let textString = "" + text;
			let middotIndex = textString.indexOf("·");
			if (middotIndex > 3 && textString.length > 7) {
				return `${textString.substring(0, middotIndex)} <b>${textString.substring(middotIndex - 1, textString.length)}</b>`;
			}
		}

		return text;
	}

	@ViewChild("searchinput") searchInputElementRef: ElementRef;

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shell/main-menu.component.ts